import { render, staticRenderFns } from "./systemServiceList.vue?vue&type=template&id=36b406f5&scoped=true&"
import script from "./systemServiceList.vue?vue&type=script&lang=js&"
export * from "./systemServiceList.vue?vue&type=script&lang=js&"
import style0 from "./systemServiceList.vue?vue&type=style&index=0&id=36b406f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b406f5",
  null
  
)

export default component.exports